/** Mirrors the reasons cancelExecutorReplyWait reports when it did not cancel. */
export enum ReplyWaitCancelFailure {
  NOT_FOUND = 'NOT_FOUND',
  NOT_OPEN = 'NOT_OPEN',
  STALE = 'STALE',
  REJECTED = 'REJECTED',
  ALREADY_EXECUTED = 'ALREADY_EXECUTED',
}
